<template>
  <div class="logo-block impact-module">
    <div class="inner">
      <div v-if="data.has_border" class="border"></div>

      <div v-if="data.title" class="title">
        <div class="title-inner">
          <h2>{{ data.title }}</h2>
        </div>
      </div>

      <div class="logos">
        <img v-for="(logo, index) in data.logo" :src="logo.poster" :alt="logo.alt" :key="index" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogosectionBlock',
  props: {
    data: Object,
  },
}
</script>

<style scoped>
.logo-block {
  padding: 0 2rem;
}

.logo-block > .inner {
  /* border-top: 1px dashed white; */
  /* padding: 10rem 0; */
  /* padding: 6rem 0; */
}

.title .title-inner {
  /* border-top: 1px dashed white;
  padding-top: 5rem; */
  /* padding-top: 10rem; */
  /* padding-top: 6rem; */
}

.title h2 {
  font: var(--nord-title);
  text-align: center;
  margin-bottom: 1rem;
}

.logos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.logos img {
  width: 25%;
  aspect-ratio: 3/2;
  object-fit: contain;
  padding: 1rem 4rem;
  max-width: 400px;
}

@media (max-width: 1000px) {
  .logos img {
    width: 50%;
    aspect-ratio: 3/2;
    object-fit: contain;
  }
}
</style>
